import {
  Backend,
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { isDefined } from '@freelancer/utils';
import { SearchUsersCollection } from './search-users.types';

export function searchUsersBackend(): Backend<SearchUsersCollection> {
  return {
    // TODO: Sort by user reputation score after adding it to the response of
    // the API endpoint (T126805).
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    // TODO: Add keyword filter after D136560 lands in production.
    fetch: (authUid, ids, query) => {
      const isOnline = getQueryParamValue(query, 'isOnline')[0];

      if (isDefined(isOnline) && !isOnline) {
        throw new Error('Cannot filter offline users');
      }

      return {
        endpoint: 'users/0.1/users/directory/',
        isGaf: false,
        params: {
          // Projections
          avatar: true,
          country_details: true,
          jobs: true,
          online_offline_details: true,
          online_only: isOnline,
          preferred_details: true,
          profile_description: true,
          reputation: true,
          status: true,

          // Filters
          query: query?.searchQueryParams?.query,
          hourly_rate_max: getQueryParamValue(query, 'hourlyRate', param =>
            param.condition === '<=' ? param.value : undefined,
          ).filter(isDefined)[0],
          hourly_rate_min: getQueryParamValue(query, 'hourlyRate', param =>
            param.condition === '>=' ? param.value : undefined,
          ).filter(isDefined)[0],
          pool_ids: getQueryParamValue(query, 'poolIds')[0],
          rating: getQueryParamValue(query, 'rating')[0],
          skills: getQueryParamValue(query, 'skills')[0]?.map(
            skill => skill.id,
          ),
          offset: query?.searchQueryParams?.offset,
        },
      };
    },
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
